<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">ACKNOWLEDGEMENTS</p>
<ul>
<li>To the archivists and librarians in Special Collections at the Library of Virginia who helped me track down old photographs for this book from the Visual Studies Collection.</li>
<li>To the archivists and librarians in the Manuscripts Room at the Library of Virginia who helped me rummage through dusty executive papers in the State Records Collection.</li>
<li>To the archivists and librarians at Local History/Special Collections at the Barrett Branch Library in Alexandria who have provided invaluable advice and support.</li>
<li>And to Hope Nelson, my partner in crime and my inspiration.</li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?f01d0ab8